import { Type } from "@sinclair/typebox";
import { DeviceChannelConfigSchema, DeviceTypeSchema, MsgrDeviceStatusSchema, } from "../../../database/models";
import { NullableNumber, NullableString } from "../../../utils/typeboxTypes";
export { DeviceTypeSchema };
export const Device = Type.Object({
    type: DeviceTypeSchema,
    /**
     * Device identifier dp-messenger-device-id
     */
    device_id: Type.String(),
    /**
     * Device token for push notifications.
     */
    device_token: Type.Optional(Type.String()),
}, {
    title: "Device",
});
export const MsgrDeviceSchema = Type.Object({
    id: Type.Number(),
    uid: Type.String({ maxLength: 50 }),
    person_id: NullableNumber,
    type: DeviceTypeSchema,
    status: MsgrDeviceStatusSchema,
    is_validated: Type.Boolean({ default: false }),
    validated_at: NullableString,
    info: NullableString,
    meta_data: NullableString,
    last_active_at: NullableString,
    last_offline_at: NullableString,
    created_at: Type.String(),
    updated_at: Type.String(),
    deleted_at: NullableString,
});
export const DeviceChannelSchema = Type.Object({
    id: Type.Number(),
    device_id: Type.Number(),
    notification_channel_id: Type.Number(),
    config: DeviceChannelConfigSchema,
    created_at: Type.String(),
    updated_at: Type.String(),
});
